import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
`;

interface ContactUsButtonProps {
  label?: string;
}

const ContactUsButton: React.FC<ContactUsButtonProps> = ({ label }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    navigate("/contactUs");
  };

  return (
    <Container>
      <Button
        variant="contained"
        onClick={handleClick}
        sx={{
          backgroundColor: "rgb(197 59 108)",
          color: "white",
          "&:hover": {
            backgroundColor: "white",
            color: "rgb(197 59 108)",
          },
        }}
      >
        {label || t("company.contactUs")}
      </Button>
    </Container>
  );
};

export default ContactUsButton;
